import React from "react";
import { Box, Typography, Avatar, Grid, ListItem, List, Tooltip,capitalize } from "@mui/material";
import RectangleIcon from "@mui/icons-material/Rectangle";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import queryGraphql from "../../helpers/ApiInterface";
interface ServiceRequestsTableProps {
	services: any;
	resourceStatuses: any;
}

const ServiceRequestsTable: React.FC<ServiceRequestsTableProps> = ({
	services, resourceStatuses
}: any) => {
	const [cardHoverIndex, setCardHoverIndex] = React.useState<number | null>(null);
	const navigate = useNavigate();


	return (
		<List sx={{ bgcolor: "#fafafa" }}>
			<ListItem sx={{ bgcolor: "#f2f2f2", borderRadius: "4px" }}>
				<Box width="100%">
					<Grid container direction="row" alignItems="center">
						<Grid item xs={2}>
							<Typography fontSize="12px">SERVICE NAME</Typography>
						</Grid>
						{/* <Grid item xs={1.5}>
							<Typography fontSize="12px">APPLICATION NAME</Typography>
						</Grid> */}

						<Grid item textAlign="start" xs={3}>
							<Typography fontSize="12px">OWNER</Typography>
						</Grid>
						<Grid item textAlign="start" xs={2}>
							<Typography fontSize="12px">REQUESTED ON</Typography>
						</Grid>
						<Grid textAlign="start" item xs={3}>
							<Typography fontSize="12px">ACTIONED BY/ REASON</Typography>
						</Grid>
						<Grid item textAlign="start" xs={2}>
							<Typography fontSize="12px">ACTIONED ON</Typography>
						</Grid>
					</Grid>
				</Box>
			</ListItem>
			{services.map((service: any, index: number) => (
				<ListItem
					sx={{
						border: cardHoverIndex == index ? "1px solid #000" : "1px solid #00000000",
						mt: 1,
						cursor: "pointer",
						bgcolor:
							service.status == "active"
								? "#FFFFFF"
								: service.status == "rejected"
								? "#F0443810"
								: "#FDB02210",
						borderRadius: "8px",
					}}
					onClick={() => {
						navigate(`/requests/services/details/${service.id}`);
					}}
					onMouseEnter={() => setCardHoverIndex(index)}
					onMouseLeave={() => {
						setCardHoverIndex(null);
					}}
				>
					<Box width="100%" sx={{}}>
						<Grid container direction="row" alignItems="center" justifyContent="space-between">
							<Grid item xs={2}>
								{
									<Box sx={{ display: "flex", alignItems: "center" }}>
										<RectangleIcon
											sx={{
												color:
													service.status == "active"
														? "#12B76A"
														: service.status == "rejected"
														? "#F04438"
														: "#FDB022",
												bgcolor:
													service.status == "active"
														? "#12B76A"
														: service.status == "rejected"
														? "#F04438"
														: "#FDB022",
												width: "4px",
												marginRight: "8px",
											}}
										/>
										<Typography fontSize="14px" fontFamily="Gilroy-Medium">
											{service.serviceName}
										</Typography>{service && service.status === 'active' ? ( 
																				  <Tooltip
																					sx={{ whiteSpace: "pre-line" }}
																					title={
																					  <Box key="applications-tooltip"> 
																						Current Status
																						<br />
																						{resourceStatuses.filter((e:any) => e.resourceId == service.id).map((e: any, index: number) => (
																						  <React.Fragment key={index}>
																							{capitalize(e.currentStatus)}
																							<br />
																						  </React.Fragment>
																						))}
																						
																					  </Box>
																					}
																				  >
																					<Avatar
																					  src="/assets/info.svg"
																					  alt="info"
																					  sx={{ height: 16, width: 16, marginLeft: "4px" }}
																					/>
																				  </Tooltip>
																				) : null}

										
									</Box>
								}
							</Grid>
							{/* <Grid item xs={1.5}>
								{
									<Box display="flex" alignItems="center" justifyContent="space-between">
										<Typography fontSize="14px" fontFamily="Gilroy-Regular">
											{service?.application?.applicationName}
										</Typography>
									</Box>
								}
							</Grid> */}
							<Grid item xs={3}>
								{
									<Box sx={{ display: "flex", alignItems: "center" }}>
										<Avatar
											src={service.serviceOwnerAvatar}
											alt={service.serviceOwner}
											sx={{ marginRight: "8px", height: 30, width: 30 }}
										/>
										<Typography fontSize="14px" fontFamily="Gilroy-Regular">
											{service.serviceOwner}
										</Typography>
									</Box>
								}
							</Grid>
							<Grid item xs={2}>
								{
									<Box display="flex" alignItems="center" justifyContent="space-between">
										<Typography fontSize="14px" fontFamily="Gilroy-Regular">
											{moment(service.createdAt).format("DD/MM/YYYY | hh:mm A")}
										</Typography>
									</Box>
								}
							</Grid>
							<Grid item xs={3}>
								{service.status != "pending" && (
									<Box sx={{ display: "flex", alignItems: "center" }}>
										<Avatar
											src={service.serviceApproverAvatar}
											alt={service.serviceApprover}
											sx={{ marginRight: "8px", height: 30, width: 30 }}
										/>
										<Typography fontSize="14px" fontFamily="Gilroy-Regular" mr={1}>
											{service.serviceApprover}
										</Typography>
										{service.status == "rejected" && (
											<Tooltip title={`Reason: ${service.reasonForRejection}`}>
												<img src="/assets/info.svg" alt="info" />
											</Tooltip>
										)}
									</Box>
								)}
							</Grid>
							<Grid item xs={2}>
								{service.status != "pending" && (
									<Box display="flex" alignItems="center" justifyContent="space-between">
										<Typography fontSize="14px" fontFamily="Gilroy-Regular">
											{moment(service.actionedAt).format("DD/MM/YYYY | hh:mm A")}
										</Typography>
									</Box>
								)}
							</Grid>
						</Grid>
					</Box>
				</ListItem>
			))}
		</List>
	);
};

export default ServiceRequestsTable;
